module.exports = __webpack_public_path__ + "assets/img/testi1.df6d5c53.jpg";